import { Loader2 } from "lucide-react";
import { CardContent, CardHeader, CardTitle } from "../../../shadcn/Card";
import { ContactLink } from "../../common/ContactLink";

interface SearchErrorMessageProps {
  error?: Error | null;
  showContactLink?: boolean;
}

export const SearchErrorMessage = ({
  error,
  showContactLink = true,
}: SearchErrorMessageProps) => {
  if (error?.name === "MonthlyLimitExceeded") {
    return (
      <>
        You've reached your monthly search limit. Please{" "}
        {showContactLink ? (
          <ContactLink />
        ) : (
          "contact us"
        )}{" "}
        to purchase additional credits.
      </>
    );
  }

  return (
    <>
      {error?.message || "An error occurred while searching. Please try again."}
    </>
  );
};

interface SearchErrorContentProps {
  error?: Error | null;
  isFetching?: boolean;
  clearSearchButton: React.ReactNode;
}

export const SearchErrorContent = ({
  error,
  isFetching = false,
  clearSearchButton,
}: SearchErrorContentProps) => {
  return (
    <CardHeader className="py-3">
      <CardTitle className="text-center text-xl relative">
        {error?.name === "MonthlyLimitExceeded"
          ? "Insufficient Credits"
          : "Search Error"}
        {isFetching && (
          <Loader2 className="absolute right-0 top-0 animate-spin h-5 w-5" />
        )}
      </CardTitle>
      <CardContent className="flex text-sm text-center flex-col items-center gap-3">
        <div className="mb-2 text-gray-500">
          <SearchErrorMessage error={error} />
        </div>
        {clearSearchButton}
      </CardContent>
    </CardHeader>
  );
};
